<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col><v-icon @click="isColorPickerOpen = !isColorPickerOpen" color="primary">mdi-brush-outline</v-icon>
                    
                </v-col>
                <!--<v-col class="text-left">
                    <v-btn-toggle v-model="selectedChart"
                                  shaped
                                  mandatory>
                        <v-btn value="chart1">
                            {{$t('ChartOne')}}
                        </v-btn>

                        <v-btn value="chart2">
                            {{$t('ChartTwo')}}
                        </v-btn>

                        <v-btn value="chart3">
                            {{$t('ChartThree')}}
                        </v-btn><v-btn value="chart4">
                            {{$t('ChartFour')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>-->
            </v-row>
           
            <!-- Color Picker Dialog -->
            <v-dialog v-model="isColorPickerOpen" max-width="400">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-color-picker v-model="chartColor" mode="hexa"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" text @click="isColorPickerOpen = false">
                            {{$t('Close')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-text>
        <v-card-text class="align-center" v-if="selectedChart === 'chart1'">
            <table><tr>
                       <td v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                           <div class="vertical-bar">
                               <div class="barcontainer" :style="{ height: item.value + '%' }">{{ item.value }}%<div class="bar" :style="{backgroundColor:chartColor}"></div></div>

                           </div>
                           <div class="barname">
                               <center>
                                   <!--<img height="30" v-if="item.name == 'سناب شات'" src="../../assets/images/snap.png" />
                                   <img height="30" v-if="item.name == 'واتساب'" src="../../assets/images/Wats.png" />
                                   <img height="30" v-if="item.name == 'تيك توك'" src="../../assets/images/TikTok.png" />
                                   <img height="30" v-if="item.name == 'تيليجرام'" src="../../assets/images/Telegram.png" />
                                   <img height="30" v-if="item.name == 'أخرى'" src="../../assets/images/Other.png" />
                                   <img height="30" v-if="item.name == 'رسالة نصية من الوزارة'" src="../../assets/images/Sms.jpg" />
                                   <img height="30" v-if="item.name == 'متطوعين'" src="../../assets/images/Group.png" />
                                   <img height="30" v-if="item.name == 'QR كود'" src="../../assets/images/Qr.png" />
                                   <img height="30" v-if="item.name == 'منصة الإستبيانات'" src="../../assets/images/Survey.png" />
                                   <img height="30" v-if="item.name == 'منصة اكس (تويتر سابقاً)' || item.name == 'منصة X'" src="../../assets/images/X.png" />-->
                               </center>
                               <span>{{ item.name }}</span>
                           </div>
                       </td></tr>
            </table>

        </v-card-text>
        <!--<v-card-text v-if="selectedChart === 'chart2'">
            <div class="chart-item" v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                <v-row>
                    <v-col cols="4">
                        <table style="background-color: #f2f2f2; width: 200px; height: 35px; padding: 0px 10px; color: #3090A0">
                            <tr>
                                <td>{{ item.name }}</td>
                                <td style="width:20%">
                                    <img height="40" v-if="item.name == 'سناب شات'" src="../../assets/images/snap.png" />
                                    <img height="40" v-if="item.name == 'واتساب'" src="../../assets/images/Wats.png" />
                                    <img height="40" v-if="item.name == 'تيك توك'" src="../../assets/images/TikTok.png" />
                                    <img height="40" v-if="item.name == 'تيليجرام'" src="../../assets/images/Telegram.png" />
                                    <img height="40" v-if="item.name == 'أخرى'" src="../../assets/images/Other.png" />
                                    <img height="40" v-if="item.name == 'رسالة نصية من الوزارة'" src="../../assets/images/Sms.jpg" />
                                    <img height="40" v-if="item.name == 'متطوعين'" src="../../assets/images/Group.png" />
                                    <img height="40" v-if="item.name == 'QR كود'" src="../../assets/images/Qr.png" />
                                    <img height="40" v-if="item.name == 'منصة الإستبيانات'" src="../../assets/images/Survey.png" />
                                    <img height="40" v-if="item.name == 'منصة اكس (تويتر سابقاً)'" src="../../assets/images/X.png" />
                                </td>
                            </tr>
                        </table>
                    </v-col>

                    <v-col>
                        <div class="chart-bar" :style="{ width: item.value + '%', backgroundColor: chartColor }"><div style="width:30px; color: #000;">{{ item.value }}%</div></div>
                    </v-col>
                </v-row>



            </div>
        </v-card-text>
        <v-card-text v-if="selectedChart === 'chart3'">
            <v-row>
                <v-col v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                    <div class="d-flex flex-column justify-center align-center" :style="`background-color:${ chartColor };color:white;height:${120 + item.value}px;width:${120 + item.value }px;text-align:center;border-radius:100%`">
                        <span>{{item.value}}%</span>
                        <span>{{item.name}}</span>
                        <span>({{item.count}})</span>
                    </div>
                </v-col>


            </v-row>
        </v-card-text>
        <v-card-text class="align-center" v-if="selectedChart === 'chart4'">
            
            <table>
                <tr>
                    <td v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                        <div class="vertical-bar">
                            <div class="barcontainer2" :style="{ height: item.value + '%' }"><div style=" background-color: white; border: 1px solid lightgray;padding:1px;width:auto;margin-top:-5px;margin-bottom:5px">{{ item.value }}%</div><div class="bar" :style="{backgroundColor:chartColor}"></div></div>

                        </div>
                        <div class="barname">

                            <span>{{ item.name }}</span>
                        </div>
                    </td></tr>
            </table>

        </v-card-text>-->
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            title: {
                type: String,
                default: () => '',
            },
        },
        data() {
            return {
                
                selectedChart: 'chart1', // Default to horizontal view
                isColorPickerOpen: false, // Controls the dialog visibility
                chartColor: '#00bcd4', // Default chart color
            }
        },
    }
</script>

<style scoped>
    .chart-card {
        width: 30%;
        padding: 16px;
        background-color: #f5f5f5;
        border-radius: 8px;
    }

    .chart-title {
        background-color: #00bcd4;
        color: white;
        padding: 8px;
        border-radius: 4px;
        text-align: center;
    }

    .chart-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
    }

    .chart-bar {
        height: 35px;
        line-height:35px;
        color: white;
        text-align: right;
        padding-right: 8px;

        min-width: 0px;
    }

    .vertical-bar {
        display: flex;
        flex-direction: column;
        align-items: center;
        height:120px;
        position:relative;
        width:30px;
        margin:0 10px;
    }
    .barcontainer {
        position: absolute;
        bottom: 30px;
        text-align:center;
        color: #000;
    }
    .barname {
        position1: absolute;
        bottom1: 0px;
        width: 50px;
        word-wrap: break-word;
        height: 180px;
        color: #000;
    }

        .barname span {
            display: block;
            transform: rotate(-70deg);
            width: 180px !important;
            margin-top: 80px;
            margin-right: -30px;
            height: 10px;
        }
    .barcontainer2 {
        position: absolute;
        bottom: 70px;
        text-align: center;
        color: #000;
    }
    .bardivier{
        width:100%;
        bottom:60px;
        background-color:lightgray;
        height:1px;
        position:absolute
    }
    .barname2 {
        position: absolute;
        bottom: 0px;
        font-size: 11px;
        text-align: center;
    }
    .bar {
        width: 30px;
        height:100%;
        color: white;
        text-align: center;
    }
    .titlebackground {
        background-image: url('/public/titlebackground.png');
        background-repeat:no-repeat;
        height:51px;
        background-size:contain;
        width:100%;
        color:white;
        padding:0 10px;
        line-height:51px;
        background-position:right
    }
</style>
